import {AfterViewInit, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import * as _ from 'lodash';

@Component({
  selector: 'dcu-input-search',
  templateUrl: './input-search.component.html',
  styleUrls: ['./input-search.component.scss']
})
export class InputSearchComponent implements OnInit, AfterViewInit {

  @Input() placeholder = '';

  @Input() searchId: string = 'input-search';

  @Output()
  statusChange = new EventEmitter();

  @Output('doSearch')
  searchedValueChange = new EventEmitter();
  textInput: string;

  constructor() {
  }

  ngOnInit() {
  }

  search(searchInput: string) {
    if (searchInput) {
      searchInput = _.toLower(_.trim(searchInput));
    }
    this.searchedValueChange.emit(searchInput);
  }

  clearInput() {
    this.textInput = '';
    this.searchedValueChange.emit('');
  }

  ngAfterViewInit(): void {
  }
}
